import React from 'react';
import styled from 'styled-components';

import { EmptyState, EmptyText } from 'components/customer/answer_panel/lib/empty_state';
import EyeIcon from 'components/lib/icons/eye_icon';

export default function EmptyAnswerPreview() {
  return (
    <Empty data-aid="emptyAnswerPreview">
      <EyeIcon />
      <EmptyText>Nothing To Show</EmptyText>
    </Empty>
  );
}

const Empty = styled(EmptyState)`
  .eyeIcon {
    height: 60px;
    width: 60px;
  }
  .eyeIcon-circle {
    fill: ${p => p.theme.colors.gray100};
  }
  .eyeIcon-stroke {
    stroke: ${p => p.theme.colors.green400};
  }
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/answer_panel/preview/empty_answer_preview.jsx